import { i18n as i } from "../i18n";

export const ERROR_CODE_MAP: Record<number, string> = {
  11: i('参数错误'),
  13: i('服务异常，请重试'),
  20000: i('无法删除非自己创建的应用'),
  20055: i('尚未设置推送账号'),
  20056: i('只有推送账号本人可以修改'),
  20057: i('推送账号必须是本客户开发者'),
  20058: i('请先保存回调地址'),
  20059: i('回调地址不能为空'),
  20060: i('回调地址格式不合法'),
  20061: i('当前登录人不是该AccessKey的创建人'),
  20062: i('AccessKey不存在'),
  20063: i('名称不能为空'),
  20064: i('描述不能为空'),
  20065: i('过期时间不能为空'),
  20066: i('过期时间不足24小时'),
  33403: i('续期时间校验不通过'),
  33404: i('仅未过期的全新V3可操作'),
  33405: i('AccessKey已是V3'),
};
  